import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SelectField } from '@flightstats/component-lib';
import componentBase from '../../../../../../../src/lib/component-base';
import FSFlatButton from '../../../../../../../src/components/lib/FSFlatButton';
import TextAreaWrapper from '../../../../../../../src/components/lib/TextArea';
import { handleFormInputValue } from '../../../../../redux/actions';

@componentBase('AdditionalInfo')
export default class AdditionalInfo extends Component {
  static propTypes = {
    formReset: PropTypes.func,
    industries: PropTypes.array,
    inputObjectDefaults: PropTypes.object,
    onSubmit: PropTypes.func,
    userIndustrySelect: PropTypes.string,
    userIndustrySelectInvalid: PropTypes.string,
    userExportIntendedUse: PropTypes.string,
    userExportIntendedUseInvalid: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.intendedUseTextValidation = this.intendedUseTextValidation.bind(this);
  }

  get dispatcher() {
    return this.context.store.dispatch;
  }

  get invalid() {
    const invalid = {
      industry: false,
      intended: false,
    };
    const {
      userIndustrySelectInvalid,
      userExportIntendedUseInvalid,
    } = this.props;
    if (userIndustrySelectInvalid) {
      invalid.industry = userIndustrySelectInvalid;
    }
    if (userExportIntendedUseInvalid) {
      invalid.intended = userExportIntendedUseInvalid;
    }
    return invalid;
  }

  handleIndustrySelect = (e) => {
    const value = e && e.value ? e.value : null;
    const { userIndustrySelect } = this.props && this.props.inputObjectDefaults;
    const input = Object.assign({}, userIndustrySelect, { value });
    this.dispatcher(handleFormInputValue(input));
  }

  intendedUseTextValidation = () => ({
    name: 'userExportIntendedUse',
    type: 'text',
  });

  filterIndustries = options => options.filter(option =>
    this.props.industries.includes(option) > -1);

  render() {
    const { store } = this.context;
    const { userExportIntendedUse } = this.props;
    const buttonStyle = { height: '45px', width: '100%' };

    return (
      <div className='data-export-additional-info row'>
        <div className='additional-info-prompt col-xs-12'>
          <p>Please fill in the following fields to help us understand how the data is being used
          and to better serve you
          </p>
        </div>
        <div className='user-intended-use-form-group col-xs-12 col-sm-5'>
          <div className='user-intended-use-inner'>
            <label
              id='userExportIntendedUse'
              htmlFor='user-intended-use'
              className={`${this.invalid.intended ? 'data-export-form-error' : ''}`}
            >
              Intended Use of Data {this.invalid.intended || null}
            </label>
            <div className='user-intended-use-textarea-wrapper'>
              <TextAreaWrapper
                dispatch={store.dispatch}
                onChange={handleFormInputValue}
                value={userExportIntendedUse}
                validationData={this.intendedUseTextValidation()}
              />
            </div>
          </div>
        </div>
        <div className='col-xs-12 col-sm-offset-1 col-sm-4'>
          <div className='user-intended-use-inner'>
            <div className='user-industry-select-form-group'>
              <label
                id='userExportIndustrySelect'
                className={`${this.invalid.industry ? 'data-export-form-error' : ''}`}
                htmlFor='user-industry-select'
              >
                Your Industry {this.invalid.industry || ''}
              </label>
              <SelectField
                ref='user-industry-select'
                handleMenuSelection={this.handleIndustrySelect}
                results={this.props.industries}
                value={this.props.userIndustrySelect}
                clearable
                selectWrapperPosition='relative'
                textColor='white'
                placeholderColor='white'
                iconColor='white'
                bgColor='rgb(129, 136, 144)'
              />
            </div>
            <div className='data-export-form-buttons row'>
              <div className='col-xs-12'>
                <FSFlatButton
                  className='get-quote-btn'
                  style={buttonStyle}
                  label='GET A QUOTE'
                  primary
                  onClick={this.props.onSubmit}
                />
              </div>
              <div className='col-xs-12'>
                <FSFlatButton
                  className='reset-fields-btn'
                  style={buttonStyle}
                  backgroundColor='rgb(239, 71, 24)'
                  hoverColor='#81A2CA'
                  label='RESET ALL FIELDS'
                  primary
                  onClick={this.props.formReset}
                />
              </div>
            </div>
          </div>
        </div>
      </div>);
  }
}



// WEBPACK FOOTER //
// ./modules/DataExports/components/ExportsSearch/children/CompileDataForm/children/AdditionalInfo.js